function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { nanoid } from "nanoid";
import { useCombobox } from "downshift";
import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
/*
	// ${(p) => (p.$isSelected ? "bg-grayscale-lighter" : "")}
	// ${(p) => (p.$isFocused ? "bg-grayscale-lighter" : "bg-grayscale-dark")}
	// ${(p) => (p.Disabled ? "text-[#686a6c]" : "text-white")}}
*/ // 	${(p) => (p.$isSelected ? "bg-grayscale-light" : "bg-grayscale-dark")}
export const DS2Item = tw.li`
	cursor-pointer
	bg-opacity-50
	bg-grayscale-light
	${(p)=>p.$isSelected ? "bg-opacity-90" : "bg-opacity-50"}
	${(p)=>p.$isFocused ? "bg-opacity-100" : ""}

	py-2
	px-3

	text-white
 ${(p)=>p.$isDisabled ? "opacity-50" : ""}
`;
export const Input = tw.input`
	appearance-none
	shadow-none
	rounded-md
	border
	border-white
	border-opacity-10
	focus:outline-0
	focus:border-solid
	focus:border-opacity-25
	hover:border-opacity-25
  !bg-grayscale-light
	py-2
	px-3

	h-10

	w-full !max-w-[375px]
	text-white

	cursor-pointer
`;
// const dropdownSelectStyles = {
// 	position: "absolute",
// 	top: "100%",
// 	zIndex: 20,
// 	overflow: "hidden",
// 	boxSizing: "border-box",
// 	backgroundColor: "#23272E",
// 	paddingTop: "0px!important",
// 	margin: "5px 0",
// 	width: "auto",
// 	minWidth: "200px",
// 	maxWidth: "600px",
// 	cursor: "pointer",
// 	borderRadius: "0.375rem",
// 	borderStyle: "solid",
// 	borderWidth: "1px",
// 	borderColor: "rgba(255, 255, 255, 0.07)",
// 	boxShadow: "0 0px 6px 0 rgba(0,0,0,0.25)",
// }
const MenuStyles = `
	absolute
	max-h-40
	overflow-y-auto
	overflow-x-hidden
	mt-1
	py-1


	bg-grayscale-dark

	shadow-none
	rounded-md
	border
	border-white
  w-auto
	border-opacity-10

	overflow-scroll

	text-white

	divide-y
	divide-solid
	divide-white
	divide-opacity-10

`;
export const Menu = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { children } = _param, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx("ul", _object_spread_props(_object_spread({
        ref: ref,
        style: {
            zIndex: 500
        },
        className: `
			${MenuStyles}
			${props.$isOpen ? "" : "hidden"}
		`
    }, props), {
        children: children
    }));
});
Menu.displayName = "Menu";
export const ControllerButton = tw.button`
	bg-transparent
	border-none
	absolute
	right-4
	cursor-pointer
	top-3
`;
function ArrowIcon({ isOpen }) {
    return /*#__PURE__*/ _jsx("svg", {
        viewBox: "0 0 20 20",
        preserveAspectRatio: "none",
        width: 16,
        fill: "transparent",
        stroke: "#979797",
        strokeWidth: "1.1px",
        transform: isOpen ? "rotate(180)" : undefined,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1,6 L10,15 L19,6"
        })
    });
}
function ArrowIcon2({ isOpen }) {
    return /*#__PURE__*/ _jsx("svg", {
        width: 16,
        transform: isOpen ? "rotate(180)" : undefined,
        fill: "rgba(255, 255, 255, 0.2)",
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        })
    });
}
function XIcon() {
    return /*#__PURE__*/ _jsxs("svg", {
        viewBox: "0 0 20 20",
        preserveAspectRatio: "none",
        width: 12,
        fill: "transparent",
        stroke: "#757679",
        strokeWidth: "2.1px",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M1,1 L19,19"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19,1 L1,19"
            })
        ]
    });
}
// const ExampleDownshift = ({}: {items: any[], rest: Downshift['props']}) => {
export const SDropdownSelectV2 = (_param)=>{
    var { itemToString, items: _items, renderItem, disallowEmpty } = _param, rest = _object_without_properties(_param, [
        "itemToString",
        "items",
        "renderItem",
        "disallowEmpty"
    ]);
    const [inputId] = useState(nanoid());
    const [items, setItems] = useState(_items);
    const [shouldBlurInput, setShouldBlurInput] = useState(false);
    // @ts-ignore
    const stateReducer = React.useCallback((state, actionAndChanges)=>{
        const { type, changes } = actionAndChanges;
        console.log(`[!] stateReducer`, type, changes, state);
        // returning an uppercased version of the item string.
        switch(type){
            case useCombobox.stateChangeTypes.InputChange:
                let setHightlightedIndex = undefined;
                // Once we start typing, let's figure out if we don't have a
                // highlightedIndex, and if we don't, let's set it to 0.
                if (changes.inputValue.length > 0) {
                    if (changes.highlightedIndex === -1) {
                        setHightlightedIndex = 0;
                    }
                }
                console.log(`[!] stateReducer - InputChange`, changes.inputValue, setHightlightedIndex);
                return _object_spread_props(_object_spread({}, changes, typeof setHightlightedIndex != "undefined" ? {
                    highlightedIndex: setHightlightedIndex
                } : {}), {
                    // but taking the change from default reducer and uppercasing it.
                    inputValue: changes.inputValue
                });
            // also on selection.
            case useCombobox.stateChangeTypes.ItemClick:
            case useCombobox.stateChangeTypes.InputKeyDownEnter:
                // Hack: Not sure how to best express this side effect...
                // Set this value, which we consume in a useEffect to blur the input.
                setShouldBlurInput(true);
                return _object_spread({}, changes, changes.selectedItem && {
                    // we will show it uppercased.
                    inputValue: changes.inputValue
                });
            case useCombobox.stateChangeTypes.InputBlur:
                return _object_spread({}, changes, changes.selectedItem && {
                    // we will show it uppercased.
                    inputValue: itemToString(changes.selectedItem)
                });
            case useCombobox.stateChangeTypes.InputClick:
                return _object_spread({}, changes, changes.selectedItem && {
                    // we will show it uppercased.
                    inputValue: ""
                });
            default:
                return changes // otherwise business as usual.
                ;
        }
    }, []);
    // Try to blur the selection on click or enter
    useEffect(()=>{
        if (shouldBlurInput) {
            setShouldBlurInput(false);
            const inputElement = document.getElementById(inputId);
            if (inputElement && inputElement === document.activeElement) {
                inputElement.blur();
            }
        }
    }, [
        shouldBlurInput
    ]);
    const loggedReducer = (reducer)=>{
        return (state, action)=>{
            const newState = reducer(state, action);
            return newState;
        };
    };
    const { selectItem, getInputProps, getToggleButtonProps, getMenuProps, getItemProps, isOpen, selectedItem, highlightedIndex } = useCombobox({
        selectedItem: rest.selectedItem,
        onSelectedItemChange: (change)=>{
            if (rest.onChange) {
                rest.onChange(change.selectedItem || null, change);
            }
        },
        items,
        itemToString,
        onInputValueChange: ({ inputValue })=>{
            setItems(_items.filter((item)=>itemToString(item).toLowerCase().includes((inputValue === null || inputValue === void 0 ? void 0 : inputValue.toLowerCase()) || "")));
        },
        stateReducer: loggedReducer(stateReducer)
    });
    console.log(`input props`, getInputProps({}));
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ _jsx(Input, _object_spread({}, getInputProps({
                        id: inputId,
                        isOpen,
                        placeholder: selectedItem ? itemToString(selectedItem) : "Select..."
                    }))),
                    selectedItem && !disallowEmpty ? /*#__PURE__*/ _jsx(ControllerButton, {
                        style: {
                            marginTop: "2px"
                        },
                        onClick: ()=>{
                            selectItem(null);
                        },
                        "aria-label": "clear selection",
                        children: /*#__PURE__*/ _jsx(XIcon, {})
                    }) : /*#__PURE__*/ _jsx(ControllerButton, _object_spread_props(_object_spread({}, getToggleButtonProps()), {
                        style: {
                            marginTop: "1px"
                        },
                        children: /*#__PURE__*/ _jsx(ArrowIcon2, {
                            isOpen: isOpen
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ _jsxs(Menu, _object_spread_props(_object_spread({}, getMenuProps({
                $isOpen: isOpen
            })), {
                children: [
                    items.length === 0 ? /*#__PURE__*/ _jsx(DS2Item, {
                        $isDisabled: true,
                        children: "No results"
                    }) : null,
                    items.map((item, index)=>/*#__PURE__*/ _jsx(DS2Item, _object_spread_props(_object_spread({
                            $isFocused: highlightedIndex === index,
                            $isSelected: selectedItem === item
                        }, getItemProps({
                            item,
                            index
                        })), {
                            children: renderItem ? renderItem(item) : itemToString(item)
                        }), (item === null || item === void 0 ? void 0 : item.id) || itemToString(item)))
                ]
            }))
        ]
    });
};
SDropdownSelectV2.displayName = "ExampleDownshift";
